import React from 'react';
import { Helmet } from 'react-helmet-async';

export function SEO({
  title = 'MA Hvidevareservice',
  description = 'MA Hvidevareservice - Din lokale hvidevareservice med holdninger. Professionel service og reparation af hårde hvidevarer i Brønshøj og Storkøbenhavn.',
  ogImage = 'https://assets.auxodev.dk/assets/fa892c1f-aad0-492e-acb0-b4e96a2c8e1c/ma-standard.png',
  canonicalUrl,
}) {
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  const canonical = canonicalUrl || currentUrl;

  return (
    <Helmet>
      <html lang="da" />
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:site_name" content="MA Hvidevareservice" />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta property="og:type" content="website" />
      {canonical && <meta property="og:url" content={canonical} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
}

export default SEO;
